import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";

import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfUsePage from "./pages/TermsOfUsePage";
import DataSecurity from "./pages/DataSecurity";

const App = () => {
	return (
		<BrowserRouter>
			<Routes>
				<Route path={"/termsOfUse"} element={<TermsOfUsePage />} />
				<Route
					path={"/privacyPolicy"}
					element={<PrivacyPolicyPage />}
				/>
				<Route path={"/dataSecurity"} element={<DataSecurity />} />
			</Routes>
		</BrowserRouter>
	);
};

export default App;
